import {
  CONTACT_TIMELINE_TAKEOVER_BLOCK_ID,
  CONTACT_TIMELINE_TAKEOVER_VIEW_ID,
  ContactDetailsBlockContent,
} from "@tellescope/contact-details";
import { PageHeader } from "../../components/PageHeader";
import { useContactTimelineTakeoverPage } from "./useContactTimelineTakeoverPage";
import { useReopenSidebarAction } from "./useReopenSidebarAction";

export const ContactTimelineTakeoverPage = () => {
  const {
    block,
    enduserId,
    isFeatureEnabled,
    canUpdateObservations,
    onClose,
    onOpenTicket,
    onOpenEvent,
    onChangeEnduser,
  } = useContactTimelineTakeoverPage();

  const reopenAction = useReopenSidebarAction(enduserId ?? "");

  if (!enduserId) return null;

  return (
    <>
      <PageHeader hideTitle onClose={onClose} trailingActions={reopenAction ? [reopenAction] : []} />
      <section className="p-4 flex flex-col flex-1 min-h-0">
        <ContactDetailsBlockContent
          className="grow flex flex-col min-h-0"
          blockLayout="fill"
          viewId={CONTACT_TIMELINE_TAKEOVER_VIEW_ID}
          isFeatureEnabled={isFeatureEnabled}
          canUpdateObservations={canUpdateObservations}
          block={block}
          blockId={CONTACT_TIMELINE_TAKEOVER_BLOCK_ID}
          blockIndex={-1}
          enduserId={enduserId}
          editMode={false}
          onOpenTicket={onOpenTicket}
          onOpenEvent={onOpenEvent}
          onChangeEnduser={onChangeEnduser}
        />
      </section>
    </>
  );
};
